import { render, staticRenderFns } from "./delivered-add-or-update.vue?vue&type=template&id=2b0bc446&scoped=true"
import script from "./delivered-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivered-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./delivered-add-or-update.vue?vue&type=style&index=0&id=2b0bc446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc446",
  null
  
)

export default component.exports